<div class="container landing-container articles-page-wrapper">
  <div class="page-head">
    <div class="d-flex flex-row justify-content-between">
      <div class="pe-2">
        <h3 class="page-title" *ngIf="isShowAllArticle">Liked Articles</h3>
        <h3 class="page-title" *ngIf="!isShowAllArticle">My Articles</h3>
      </div>
      <div>
        <app-button [btnCss]="'btn btn-primary text-nowrap'" *ngIf="!isShowAllArticle && articleCreationAllowed" [btnTitle]="'Create Article'"
          [btnText]="'+ Create Article'" [routerLink]="['/article-edit']"></app-button>
      </div>
    </div>
    <form [formGroup]="formGroup">
      <div class="form-block-outer">
        <div ngbDropdown class="d-inline-block" #myDrop="ngbDropdown">
          <button class="btn btn-outline-info" *ngIf="isShowAllArticle" title="Filter" id="filter-drop"
            ngbDropdownToggle>
            <div class="svg-wrap">
              <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1.05485 2.10499C0.828945 2.10499 0.603042 2.18919 0.420168 2.32601C-0.0531511 2.68386 -0.139209 3.34693 0.226538 3.7995V3.81003L5.93864 10.967V17.2714L8.40206 19.6921C8.82159 20.1026 9.51005 20.1026 9.92959 19.6921C10.3491 19.2817 10.3491 18.6081 9.92959 18.1976L8.0901 16.4084V10.2408L1.92619 2.51546C1.8232 2.38586 1.69094 2.28136 1.53977 2.21014C1.38859 2.13893 1.22262 2.10293 1.05485 2.10499ZM14.5445 9.47244V17.7661C14.5875 18.0818 14.4799 18.4186 14.2325 18.6397C14.133 18.7372 14.0148 18.8146 13.8846 18.8674C13.7545 18.9203 13.615 18.9474 13.4741 18.9474C13.3332 18.9474 13.1937 18.9203 13.0636 18.8674C12.9334 18.8146 12.8152 18.7372 12.7157 18.6397L10.5535 16.5241C10.4362 16.4119 10.347 16.2747 10.2929 16.1231C10.2387 15.9716 10.2212 15.8099 10.2415 15.6506V9.47244H10.2093L4.01309 1.70504C3.8384 1.48563 3.75958 1.20748 3.79385 0.931383C3.82811 0.655284 3.97268 0.40368 4.19597 0.231549C4.40036 0.0841995 4.62626 0 4.86292 0H19.9231C20.1597 0 20.3856 0.0841995 20.59 0.231549C20.8133 0.40368 20.9579 0.655284 20.9922 0.931383C21.0264 1.20748 20.9476 1.48563 20.7729 1.70504L14.5767 9.47244H14.5445Z"
                  fill="currentColor" />
                <circle cx="17" cy="17" r="6" fill="#FAF8FA" />
                <path d="M13 16H16V13H18V16H21V18H18V21H16V18H13V16Z" fill="currentColor" />
              </svg>
            </div>
            Filter
          </button>
          <div ngbDropdownMenu aria-labelledby="filter-drop" class="article-filter-menu">
            <div class="dropdown-head">
              <h4 class="drop-title">Filter</h4>
              <app-button [btnCss]="'btn btn-close'" [btnText]="''" [btnTitle]="''"
                (onBtnClick)="$event.stopPropagation(); myDrop.close()"></app-button>
            </div>
            <div class="dropdown-body">
              <div class="row">
                <div class="col-md-6">
                  <label class="data-label">Upload Date</label>
                  <div class="datepicker-grp">
                    <app-datepicker-input [maxDate]="formGroup.get('toDate')?.value" placeholder="From"
                      [control]="formGroup.get('fromDate')" (dropdownShow)="toggleDropdown($event, 'from')"
                      [ngClass]="fromdropdownVisible ? 'dateClass' : ''"></app-datepicker-input>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="data-label d-none d-md-block">&nbsp;</label>
                  <div class="datepicker-grp">
                    <app-datepicker-input [minDate]="formGroup.get('fromDate')?.value" placeholder="To"
                      [control]="formGroup.get('toDate')" (dropdownShow)="toggleDropdown($event, 'to')"
                      [ngClass]="todropdownVisible ? 'dateClass' : ''"></app-datepicker-input>
                  </div>
                </div>
                <div class="col-12">
                  <app-select [selectPlaceholder]="'Select Category'" [label]="'Category'" [options]="types"
                    [selectClass]="'ng-form-select primary-select article-select'" [(selectedValue)]="typeSelect"
                    [multiSelect]="true"></app-select>
                </div>
                <div class="col-12">
                  <app-select [selectPlaceholder]="'Select People'" [label]="'Uploaded By'" [options]="peoples"
                    [selectClass]="'ng-form-select primary-select article-select'" [(selectedValue)]="peopleSelect"
                    [multiSelect]="true"></app-select>
                </div>
              </div>
            </div>
            <div class="dropdown-footer">
              <div class="btn-grps">
                <app-button [btnCss]="'btn btn-outline-danger'" [btnTitle]="'Clear All'" [btnText]="'Clear All'"
                  (onBtnClick)="clearFilter();myDrop.close()"></app-button>
                <app-button [isDisable]="!isFiterApply" [btnCss]="'btn btn-primary'" [btnTitle]="'Apply'"
                  [btnText]="'Apply'" (onBtnClick)="applyFilter();myDrop.close()"></app-button>
              </div>
            </div>
          </div>
        </div>
        <div class="aside-block">
          <div class="form-wrap">
            <app-input [inputClass]="'form-control'" *ngIf="isShowAllArticle" class="article-search-input"
              [inputType]="'search'" [isRequired]="false" [inputPlaceholder]="'Search Article'" aria-label="Search"
              [fControl]="formGroup.controls['Search']" />
            <button class="btn btn-clear-search" (click)="this.formGroup.patchValue({Search: '' })"
              [ngClass]="{'d-none':!formGroup.get('Search').value}">
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1.06698 0.183065C0.822892 -0.0610214 0.427151 -0.0610215 0.183065 0.183064C-0.0610214 0.42715 -0.0610215 0.822892 0.183064 1.06698L4.1163 5.00021L0.18349 8.93302C-0.0605962 9.17711 -0.0605961 9.57285 0.18349 9.81694C0.427576 10.061 0.823317 10.061 1.0674 9.81694L5.00015 5.88418L8.9329 9.81694C9.17699 10.061 9.57273 10.061 9.81682 9.81694C10.0609 9.57285 10.0609 9.17711 9.81682 8.93302L5.88359 4.99979L9.81639 1.06698C10.0605 0.822892 10.0605 0.42715 9.81639 0.183064C9.57231 -0.0610215 9.17657 -0.0610214 8.93248 0.183065L4.99973 4.11582L1.06698 0.183065Z"
                  fill="currentcolor" />
              </svg>
            </button>
          </div>

        </div>
      </div>
    </form>
  </div>
  <div class="articles-card-grid">
    <div *ngIf="articles?.length>0" class="row">
      <div class="col-sm-6 col-md-4" *ngFor="let article of articles">
        <app-articles-card (click)="articlePreview(article.id)" [article]="article"></app-articles-card>
      </div>
    </div>

    <div *ngIf="!articles?.length" class="no-data-found-wrap">
      <p>No Articles</p>
    </div>
  </div>
  <div *ngIf="articles?.length>0" class="pagination-wrap">
    <ngb-pagination [collectionSize]="totalRecord" [pageSize]="pagesize" [maxSize]="5" [(page)]="currentPage"
      (pageChange)="onPageChange($event)" aria-label="Default pagination">
      <ng-template ngbPaginationPrevious>
        <img src="./assets/images/ic-pagination-prev.svg" alt="Icon">
      </ng-template>
      <ng-template ngbPaginationNext>
        <img src="./assets/images/ic-pagination-next.svg" alt="Icon">
      </ng-template>
    </ngb-pagination>
  </div>
</div>
